import Auth from './Auth'
import { routerGuard } from '../common'
import { frontendcommonCss, logo, logoSmall, logoColor, logoColorSmall, colors } from './frontendcommon'
import URLS from './urls'
import { plugins } from 'frontendcommon-3'

import App from './App'
import SidebarBottom from './SidebarBottom'
import LoadingSpinner from './LoadingSpinner'

const sidebarLoading = false
const enableMobileLayout = false
const { AxiosPlugin } = plugins

const sentryDns = 'https://2491955a8a0644ed91cc620e0d11194b@sentry.farmapremium.es/3'
export {
  Auth,
  routerGuard,
  frontendcommonCss,
  colors,
  logo,
  logoSmall,
  logoColor,
  logoColorSmall,
  enableMobileLayout,
  sidebarLoading,
  SidebarBottom,
  App,
  URLS,
  AxiosPlugin,
  sentryDns,
  LoadingSpinner
}
